import actions from './actions'
import mutations from './mutations'

let state = {
    current: null
}

const ACTIONS = {
    GET: 'settings/get'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }